<template>
  <div class="lp-page careers-page">
    <Navbar />

    <!-- Hero -->
    <section class="lp-hero">
      <div class="lp-container">
        <span class="lp-eyebrow">{{ $t('careers.heroLabel') }}</span>
        <h1 class="lp-title">{{ $t('careers.heroTitle') }}</h1>
        <p class="lp-lead">{{ $t('careers.heroSubtitle') }}</p>
      </div>
    </section>

    <!-- Why join -->
    <section class="lp-section">
      <div class="lp-container">
        <div class="lp-section-head">
          <h2 class="lp-h2">{{ $t('careers.whyJoinTitle') }}</h2>
        </div>
        <div class="lp-grid lp-grid-3">
          <div class="lp-card">
            <span class="lp-ico blue"><font-awesome-icon icon="fa-solid fa-rocket" /></span>
            <h3 class="lp-h3">{{ $t('careers.innovationTitle') }}</h3>
            <p class="lp-text">{{ $t('careers.innovationDescription') }}</p>
          </div>
          <div class="lp-card">
            <span class="lp-ico green"><font-awesome-icon icon="fa-solid fa-users" /></span>
            <h3 class="lp-h3">{{ $t('careers.teamTitle') }}</h3>
            <p class="lp-text">{{ $t('careers.teamDescription') }}</p>
          </div>
          <div class="lp-card">
            <span class="lp-ico violet"><font-awesome-icon icon="fa-solid fa-chart-line" /></span>
            <h3 class="lp-h3">{{ $t('careers.growthTitle') }}</h3>
            <p class="lp-text">{{ $t('careers.growthDescription') }}</p>
          </div>
          <div class="lp-card">
            <span class="lp-ico pink"><font-awesome-icon icon="fa-solid fa-heart" /></span>
            <h3 class="lp-h3">{{ $t('careers.cultureTitle') }}</h3>
            <p class="lp-text">{{ $t('careers.cultureDescription') }}</p>
          </div>
          <div class="lp-card">
            <span class="lp-ico amber"><font-awesome-icon icon="fa-solid fa-laptop" /></span>
            <h3 class="lp-h3">{{ $t('careers.flexibilityTitle') }}</h3>
            <p class="lp-text">{{ $t('careers.flexibilityDescription') }}</p>
          </div>
          <div class="lp-card">
            <span class="lp-ico cyan"><font-awesome-icon icon="fa-solid fa-gift" /></span>
            <h3 class="lp-h3">{{ $t('careers.benefitsTitle') }}</h3>
            <p class="lp-text">{{ $t('careers.benefitsDescription') }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Open positions -->
    <section class="lp-section">
      <div class="lp-narrow">
        <div class="lp-section-head">
          <h2 class="lp-h2">{{ $t('careers.openPositionsTitle') }}</h2>
          <p class="lp-lead">{{ $t('careers.openPositionsSubtitle') }}</p>
        </div>
        <div class="positions-list">
          <div class="position-card reveal-item" v-for="i in 3" :key="i">
            <div class="position-header">
              <div>
                <h3 class="lp-h3">{{ $t(`careers.position${i}Title`) }}</h3>
                <div class="position-meta">
                  <span><font-awesome-icon icon="fa-solid fa-location-dot" /> {{ $t('careers.remoteLocation') }}</span>
                  <span><font-awesome-icon icon="fa-solid fa-clock" /> {{ $t('careers.fullTime') }}</span>
                </div>
              </div>
              <a href="/contact" class="lp-btn lp-btn-primary apply-btn">{{ $t('careers.applyNow') }}</a>
            </div>
            <p class="lp-text">{{ $t(`careers.position${i}Description`) }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="lp-section">
      <div class="lp-container">
        <div class="lp-cta">
          <h2>{{ $t('careers.ctaTitle') }}</h2>
          <p>{{ $t('careers.ctaSubtitle') }}</p>
          <a href="/contact" class="lp-btn lp-btn-primary">{{ $t('careers.contactUs') }}</a>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import { useReveal } from '../composables/useReveal';

onMounted(() => {
  window.scrollTo({ top: 0, behavior: 'instant' });
});

useReveal();
</script>

<style scoped>
.positions-list { display: flex; flex-direction: column; gap: 16px; }
.position-card { background: var(--card); border: 1px solid var(--line); border-radius: var(--radius-sm); padding: 26px 28px; box-shadow: 0 18px 44px -34px rgba(31,41,51,0.3); transition: border-color 0.2s ease, box-shadow 0.2s ease; }
.position-card:hover { border-color: rgba(43,130,240,0.35); box-shadow: 0 26px 56px -34px rgba(31,41,51,0.36); }
.position-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; margin-bottom: 12px; }
.position-header .lp-h3 { margin-bottom: 8px; }
.position-meta { display: flex; gap: 16px; flex-wrap: wrap; }
.position-meta span { display: inline-flex; align-items: center; gap: 6px; font-size: 13px; color: var(--muted); font-weight: 500; }
.apply-btn { flex-shrink: 0; padding: 10px 20px; font-size: 14px; }

@media (max-width: 600px) {
  .position-header { flex-direction: column; }
  .apply-btn { width: 100%; }
}
</style>
